import { toSignificant } from '@/utilities/formatting';
import DataTable from '@/components/DataTable';
import { slugify } from '@utilities/slugify';

export interface RawDataTimeSeriesProps {
  uniqueSymbol: string;
  title: string;
  reportingCurrencyISO: string;
  reportingUnit?: string;
  numberPrecision: number;
  tableHeaderDescriptions: readonly string[];
  tableData: readonly {
    dateKey: number;
    data: readonly number[];
  }[];
  formatNumber?: (value: string) => string;
  formatDate?: (date: Date) => string;
}

const RawDataTimeSeries = ({
  uniqueSymbol,
  title,
  reportingCurrencyISO,
  reportingUnit = '',
  numberPrecision,
  tableHeaderDescriptions,
  tableData,
  formatNumber = (value) => parseFloat(value).toLocaleString(),
  formatDate = (date) => date.toLocaleDateString(),
}: RawDataTimeSeriesProps) => (
  <DataTable light>
    <caption>{`${uniqueSymbol} ${title} (${reportingCurrencyISO} ${reportingUnit})`}</caption>
    <thead>
      <tr>
        <th>Date</th>
        {tableHeaderDescriptions &&
          tableHeaderDescriptions.map((header) => (
            <th key={`time-series-header-${slugify(header)}`}>{header}</th>
          ))}
      </tr>
    </thead>
    <tbody>
      {tableData &&
        tableData.map(({ dateKey, data }) => (
          <tr key={`time-series-row-${dateKey}`}>
            <td>{formatDate(new Date(dateKey))}</td>
            {data &&
              data.map((value) => (
                <td key={`time-series-row-data-${dateKey}-${value}`}>
                  {value === 0
                    ? `-`
                    : formatNumber(toSignificant(value, numberPrecision))}
                </td>
              ))}
          </tr>
        ))}
    </tbody>
  </DataTable>
);

export default RawDataTimeSeries;
